import { render } from "./SubAccountTransactions.vue?vue&type=template&id=7c08168e"
import script from "./SubAccountTransactions.vue?vue&type=script&lang=js"
export * from "./SubAccountTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script